export const AIRTIME_PURCHASE_STARTED = "AIRTIME_PURCHASE_STARTED";
export const AIRTIME_PURCHASE_SUCCEEDED = "AIRTIME_PURCHASE_SUCCEEDED";
export const AIRTIME_PURCHASE_FAILED = "AIRTIME_PURCHASE_FAILED";
export const SET_AIRTIME_BILLER = "SET_AIRTIME_BILLER";
export const INITIATE_AIRTIME_TRANSFER_STARTED =
  "INITIATE_AIRTIME_TRANSFER_STARTED";
export const INITIATE_AIRTIME_TRANSFER_SUCCEDEED =
  "INITIATE_AIRTIME_TRANSFER_SUCCEDEED";
export const INITIATE_AIRTIME_TRANSFER_FAILED =
  "INITIATE_AIRTIME_TRANSFER_FAILED";
